export default "__VITE_ASSET__CVJTu5pC__"